<template>
  <div>
    <div class="bottom-buttons-group">
      <v-tooltip top>
        <template v-slot:[`activator`]="{ on, attrs }">
          <v-btn fab rounded :color="colors.danger" v-bind="attrs" v-on="on" v-if="currentUser.isBroadcaster || currentUserIsAdmin"
                 @click="endMeeting"
                 class="white--text mx-1">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>پایان</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:[`activator`]="{ on, attrs }">
          <v-btn fab rounded :color="colors.danger" v-bind="attrs" v-on="on" v-if="currentUser.isBroadcaster || currentUserIsAdmin"
                 @click="closeMeeting"
                 class="white--text mx-1">
            <v-icon>mdi-exit-to-app</v-icon>
          </v-btn>
        </template>
        <span>خروج</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn fab rounded :color="colors.success" v-bind="attrs" v-on="on" v-if="currentUser.isBroadcaster || currentUserIsAdmin"
                 @click="openSetting"
                 class="white--text mx-1">
            <v-icon>mdi-cog</v-icon>
          </v-btn>
        </template>
        <span>تنظیمات</span>
      </v-tooltip>
    </div>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar
                dark
                :color="colors.success"
            >
              <v-btn
                  icon
                  dark
                  @click="dialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>تنظیمات</v-toolbar-title>
            </v-toolbar>

            <v-stepper
                v-model="step"
                vertical
            >
              <v-stepper-step v-if="currentUser.isBroadcaster || currentUserIsAdmin" step="1" complete @click="step = 1"
                              complete-icon="mdi-cog-outline" :color="colors.success">
                کاربران
                <small>مدیریت کاربران و دسترسی های آن ها</small>
              </v-stepper-step>
              <v-stepper-content step="1">
                <v-data-table
                    align="center"
                    :headers="permissionsHeader"
                    :items="permissions"
                    class="elevation-5 bordered-table"
                    :items-per-page="15"
                    hide-default-footer
                >
                  <template v-slot:[`item.microphone`]="{item}">
                    <v-btn :color="item.microphone ? colors.success : colors.danger" x-small fab
                           class="white--text" @click="item.microphone = !item.microphone">
                      <v-icon v-if="item.microphone">mdi-check</v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:[`item.webcam`]="{item}">
                    <v-btn :color="item.webcam ? colors.success : colors.danger" x-small fab
                           class="white--text" @click="item.webcam = !item.webcam">
                      <v-icon v-if="item.webcam">mdi-check</v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:[`item.screen`]="{item}">
                    <v-btn :color="item.screen ? colors.success : colors.danger" x-small fab
                           class="white--text" @click="item.screen = !item.screen">
                      <v-icon v-if="item.screen">mdi-check</v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:[`item.whiteboard`]="{item}">
                    <v-btn :color="item.whiteboard ? colors.success : colors.danger" x-small fab
                           class="white--text" @click="item.whiteboard = !item.whiteboard">
                      <v-icon v-if="item.whiteboard">mdi-check</v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:[`item.video`]="{item}">
                    <v-btn :color="item.video ? colors.success : colors.danger" x-small fab
                           class="white--text" @click="item.video = !item.video">
                      <v-icon v-if="item.video">mdi-check</v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:[`item.audio`]="{item}">
                    <v-btn :color="item.audio ? colors.success : colors.danger" x-small fab
                           class="white--text" @click="item.audio = !item.audio">
                      <v-icon v-if="item.audio">mdi-check</v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:[`item.record`]="{item}">
                    <v-btn :color="item.record ? colors.success : colors.danger" x-small fab
                           class="white--text" @click="item.record = !item.record">
                      <v-icon v-if="item.record">mdi-check</v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </v-btn>
                  </template>

                </v-data-table>
                <v-btn :color="colors.success" rounded class="white--text mb-4 mt-4" @click="saveUserPermissions">
                  ذخیره
                </v-btn>
                <v-btn :color="colors.danger" rounded class="white--text mb-4 mt-4 mr-2"
                       @click="getMeetingInfo('permissions')">
                  ریست
                </v-btn>
              </v-stepper-content>

              <v-stepper-step v-if="currentUser.isBroadcaster || currentUserIsAdmin" step="3" complete @click="step = 3"
                              complete-icon="mdi-cog-outline" :color="colors.success">
                حضور و غیاب
              </v-stepper-step>

              <v-stepper-content step="3">
                <v-data-table
                    align="center"
                    :headers="attendancesHeader"
                    :items="attendances"
                    class="elevation-5 bordered-table"
                    :items-per-page="15"
                    hide-default-footer
                >
                  <template v-slot:[`item.isAttended`]="{item}">
                    <v-btn :color="item.persian_join_time ? colors.success : colors.danger" x-small fab
                           class="white--text">
                      <v-icon v-if="item.persian_join_time">mdi-check</v-icon>
                      <v-icon v-else>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.join_time`]="{item}">
                    <span>{{ item.persian_join_time }}</span>
                  </template>
                </v-data-table>
              </v-stepper-content>

            </v-stepper>

          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "MeetingSetting",
  props: ['meetingId', 'clas', 'echo', 'currentUser', 'colors', 'currentUserIsAdmin'],

  data() {
    return {
      dialog: false,
      step: 99,

      permissions: [],
      permissionsHeader: [
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'میکروفن', value: 'microphone', align: 'center'},
        {text: 'وب کم', value: 'webcam', align: 'center'},
        {text: 'صفحه نمایش', value: 'screen', align: 'center'},
        {text: 'وایت برد', value: 'whiteboard', align: 'center'},
        {text: 'فایل تصویری', value: 'video', align: 'center'},
        {text: 'فایل صوتی', value: 'audio', align: 'center'},
        {text: 'ضبط', value: 'record', align: 'center'},
      ],

      attendances: [],
      attendancesHeader: [
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'حاضر', value: 'isAttended', align: 'center'},
        {text: 'زمان ورود', value: 'persian_join_time', align: 'center'},
      ],
    }
  },

  methods: {
    openSetting() {
      this.dialog = true;
      this.getMeetingInfo()
    },
    closeMeeting(){
      this.$emit('meeting-ended')
      this.$router.push('/classes')
    },
    endMeeting() {
      window.axios.get('/session/online-class/end/' + this.meetingId).then(() => {
        this.$emit('meeting-ended')
        this.$router.push('/classes')
      })
    },
    getMeetingInfo(type = "all") { // all - permissions - attendances
      window.axios.get('/session/online-class/info/' + this.meetingId + '?' + type).then((res) => {
        console.log(res.data.data)
        let responseData = res.data.data
        if (responseData.permissions) {
          this.permissions = responseData.permissions
        }
        if (responseData.attendances) {
          this.attendances = responseData.attendances
        }
      })
    },

    saveUserPermissions() {
      window.axios.post('/session/online-class/permissions/update', {
        permissions: this.permissions
      })
          .then(() => {
          })
          .catch((err) => {
            console.log(err)
          })
    },
  },
}
</script>

<style scoped>
.bottom-buttons-group {
  position: fixed !important;
  bottom: 20px !important;
  width: 100%;
  text-align: left;
  left: 20px !important;
}

.endMeetingBtn {
  box-shadow: none !important;
  position: fixed !important;
  bottom: 20px !important;
  left: 20px !important;
}

.exitMeetingBtn {
  box-shadow: none !important;
  position: fixed !important;
  bottom: 20px !important;
  left: 60px !important;
}

.openSettingBtn {
  box-shadow: none !important;
  position: fixed !important;
  bottom: 20px !important;
}

.bordered-table {
  padding: 10px;
  border-radius: 15px;
  border: 2px solid black;
  box-shadow: none !important;
}

.v-btn {
  box-shadow: none !important;
}

.v-stepper__step {
  cursor: pointer !important;
}
</style>